import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function CardItem({ card }) {
  return (
    <div className="casino-result-cards-item">
      <img src={getCardImage(card)} alt="" />
    </div>
  );
}

function PlayerSide({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4> <CardItem card={cards[0]} /> <CardItem card={cards[1]} />
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 20-20 Poker (poker20): A = cards[0,1], B = cards[2,3], Board = cards[4..8],
 * trophy before the winner (win 1/2); rdesc "main#other" → Main / Other.
 */
export default function Poker20ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      <div className="col-12 col-lg-5">
        <div className="casino-result-content mt-0">
          <PlayerSide name="Player A" cards={[cards[0], cards[1]]} isWinner={win === "1"} />{" "}
          <div className="casino-result-content-diveder" />{" "}
          <PlayerSide name="Player B" cards={[cards[2], cards[3]]} isWinner={win === "2"} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4 d-flex align-items-center">
        <div className="casino-result-cards d-block w-100">
          <div className="text-center">
            <h4 className="text-center">Board</h4>
            {[4, 5, 6, 7, 8].map((i) => (
              <React.Fragment key={i}>
                {" "}
                <CardItem card={cards[i]} />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-3">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Main:</div> <div>{desc[0]}</div>
          </div>{" "}
          <div className="casino-result-desc-item">
            <div>Other:</div> <div>{desc[1]}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
